import { getAssetPath } from "@commonUtils"
import { keysToCamel } from "@lib/snakeTocamel"
export const parseWidgetData = (widgets) => {
    let widgetData = {}
    widgets.forEach((widget) => {
        switch (widget.type) {
            case "descriptive_selection": {
                widgetData["descriptiveSelection"] = {
                    header: widget.data.header,
                    values: widget.data.values?.map((item, index) => {
                        return {
                            id: index,
                            header: item.header,
                            subHeader: item.display_text || "",
                            icon: item.icon,
                            defaultSelected: item.default_selected,
                            cta: item.cta,
                            lowerHeader: item.tat?.text || "",
                            lowerSubHeader: `<b>${item.tat?.time}</b> ${item.tat?.time_suffix}`,
                            lowerIcon: item.tat?.image,
                            callMeMandatory: item.call_me_mandatory,
                            toggleErrorMessage: item.snackbar?.message,
                            target: item.target,
                            showPhoneConfirmation: item.show_phone_confirmation
                                ? item.show_phone_confirmation
                                : false,
                        }
                    }),
                }
                break
            }

            case "user_notes": {
                widgetData["userNotes"] = {
                    header: widget.data.header,
                    secondaryHeader: widget.data.secondary_header,
                    cta: { icon: widget.data?.cta?.icon, action: widget.data?.cta?.action },
                    infoBottomsheet: widget.data?.info_bottomsheet?.widgets[0]?.data,
                }
                break
            }
            case "attached_prescription": {
                widgetData["attachedPrescription"] = {
                    listOfImages: widgets.attached_prescriptions?.map((item) => {
                        return {
                            image: {
                                url: item.icon,
                                xxhighUrl: item.file_url,
                                alt: "prescription",
                                id: item.id,
                                type:
                                    item.file_url?.includes("pdf") || item.file_url?.includes("application")
                                        ? "pdf"
                                        : "image",
                                cta: {
                                    functionMap: "prescriptionClicked",
                                },
                                documentUrl: item.file_url,
                            },
                            iconOnImage: {
                                url: getAssetPath("svgs/icons/cross_icon_primary_18px.svg"),
                                alt: "remove prescription",
                                cta: {
                                    functionMap: "removeIconClick",
                                },
                            },
                        }
                    }),
                }
                break
            }
            case "permission_toggle": {
                widgetData["permissionToggle"] = {
                    description: widget.data.header,
                    infoIcon: widget.data.permission_info_icon,
                    pointers: widget.data.values,
                    toggleLabel: widget.data.toggle?.toggle_text,
                    toggleDefaultValue: widget.data.toggle?.toggle_default_selected,
                }
                break
            }
            case "footnotes": {
                widgetData["footnotes"] = {
                    subHeader: widget?.data?.sub_text,
                    data: [
                        {
                            header: "",
                            displayText: `<u>${widget?.data?.sub_text_cta || ""}</u>`,
                        },
                    ],
                }
                break
            }
        }
    })
    const tempSelectedProcess = widgetData["descriptiveSelection"]?.values?.find(
        (option) => option.defaultSelected
    )
    const selectedProcess = tempSelectedProcess
        ? tempSelectedProcess
        : widgetData.descriptiveSelection?.data?.values[0]
    return { widgets: widgetData, selectedProcess: selectedProcess }
}
export const parsePageInfoWidgets = (data) => {
    let pageInfoWidgets = {}
    if (data?.cta) {
        pageInfoWidgets["actionButton"] = {
            text: data?.cta?.text,
            action: data?.cta?.action,
        }
    }
    if (data?.address_selection) {
        pageInfoWidgets["addressSelectionWidget"] = {
            icon: data.address_selection.icon,
            header: data.address_selection.header,
            addressName: data.address_selection.address_name,
            address: `${data.address_selection.street1 ? data.address_selection.street1 + ", " : ""}${
                data.address_selection.street2 ? data.address_selection.street2 + ", " : ""
            }${
                data.address_selection.city && data.address_selection.street1
                    ? decodeURI(data.address_selection.city) + ", "
                    : decodeURI(data.address_selection.city)
            }${data.address_selection.locality ? data.address_selection.locality + ", " : ""}${
                data.address_selection.state ? data.address_selection.state : ""
            }${data.address_selection.pincode ? " (" + data.address_selection.pincode + ")" : ""}`,
            ctaLabel: data.address_selection.cta?.text,
            redirectUrl: "/done-in-one/cart/address-page",
            geodataUpdateRequired: data.address_selection.is_geodata_update_required || false,
            id: data.address_selection.id,
        }
    }
    if (data?.permission_info_guide) {
        pageInfoWidgets["permissionInfoGuide"] = {
            ctaLabel: data?.permission_info_guide?.cta?.text,
            header: data?.permission_info_guide?.header,
            details: data?.permission_info_guide?.values.map((value) => {
                return {
                    header: value.header,
                    imageUrl: value.icon,
                    subHeader: value.text,
                }
            }),
        }
    }
    if (data?.phone_confirmation_data) {
        pageInfoWidgets["phoneConfirmationData"] = {
            cta: data?.phone_confirmation_data?.cta?.text,
            subHeader: data?.phone_confirmation_data?.description,
            header: data?.phone_confirmation_data?.header,
            title: data?.phone_confirmation_data?.input_title,
            phoneNumber: data?.phone_confirmation_data?.phone_number || "",
        }
    }
    if (data?.attached_prescriptions) {
        pageInfoWidgets["attachedPrescription"] = {
            listOfImages: data?.attached_prescriptions?.map((item) => {
                return {
                    image: {
                        url: item.icon,
                        xxhighUrl: item.file_url,
                        alt: "prescription",
                        id: item.id,
                        type:
                            item.file_url?.includes("pdf") || item.file_url?.includes("application")
                                ? "pdf"
                                : "image",
                        cta: {
                            functionMap: "prescriptionClicked",
                        },
                        documentUrl: item.file_url,
                    },
                }
            }),
        }
    }
    if (data?.pay_online_dialog) {
        pageInfoWidgets["payOnlineDialog"] = {
            header: data.pay_online_dialog?.header,
            subHeader: data.pay_online_dialog?.description,
            icon: data.pay_online_dialog?.icon,
            cta: data.pay_online_dialog?.confirm_cta?.text,
            resolution: data.pay_online_dialog?.resolution,
        }
    }
    if (data?.update_address_dialog_data) {
        pageInfoWidgets["updateAddressDialogData"] = {
            header: data.update_address_dialog_data?.header,
            description: data.update_address_dialog_data?.description,
            icon: data.update_address_dialog_data?.icon,
            primaryCta: {
                text: data?.update_address_dialog_data?.primary_cta?.text,
                functionMap: "currentLocation",
            },
            secondaryCta: {
                text: data?.update_address_dialog_data?.secondary_cta?.text,
                functionMap: "updateManually",
            },
        }
    }
    if (data?.wallet_info) {
        pageInfoWidgets["walletInfo"] = keysToCamel(data?.wallet_info)
    }
    if (data?.info_widget) {
        pageInfoWidgets["infoWidget"] = keysToCamel(data?.info_widget)
    }
    pageInfoWidgets["currentJob"] = data?.current_job
    return pageInfoWidgets
}
